function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, $hooks, JSON, Number, String, bookmarkId, customAlertModalOpen, open) {
    var h = require("panel").h;
    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const isSavedBookmark = !$attr(`unsaved-changes`) && Number.isInteger(bookmarkId);
    const icon = $helpers.getIcon();
    const resultsKeysAndValues = $attr(`results-keys-and-values`);
    return {
      value: (h("div", {
        "class": {
          'mp-report-config': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-report-config-button': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-button", {
            "attrs": {
              'disabled': !isSavedBookmark,
              'icon': icon,
              'size': `small`,
              'theme': `tertiary`,
              'pressed': open,
            },
            "on": {
              click: $helpers.handleClick
            },
          }));
          __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
            "attrs": {
              'max-width': `250px`
            },
          }, [__vjadeSafeCode($helpers.getTooltipText())]));
          __jade_nodes = __jade_nodes.concat(($helpers.showUnreadStatus()) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-report-config-status-icon': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                "attrs": {
                  icon: `status-light`
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-report-config-dropdown': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((open) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-alert-dropdown", {
              "hook": {
                remove: $hooks.delayedAttrRemove(`open`, false)
              },
              "attrs": {
                'open': true,
                'bookmark-id': $attr(`bookmark-id`),
                'display-context': $attr(`display-context`),
                'enable-custom-alerts': $attr(`enable-custom-alerts`),
                'enable-subscribe-alerts': $attr(`enable-subscribe-alerts`),
                'has-empty-data': $attr(`has-empty-data`),
                'has-results-keys-and-values': !!resultsKeysAndValues,
                'is-report-loading': $attr(`is-report-loading`),
                'placement': `center`,
                'project-id': $attr(`project-id`),
                'subscription-paused': $helpers.isAutomatedAlertSubscriptionPaused(),
                'utc-offset': $attr(`utc-offset`),
                'workspace-id': $attr(`workspace-id`),
              },
              "on": {
                alertsLoaded: $helpers.markAlertsLoaded,
                alertsMarkedAsRead: $helpers.handleAlertsMarkedAsRead,
                change: $helpers.handleMenuChange,
                clickedAutomatedAlertToggle: $helpers.clickedAutomatedAlertToggle,
                clickedLink: $helpers.handleClickedLink,
                createCustomAlertClicked: $helpers.clickedCreateCustomAlert,
                manageAlerts: $helpers.handleManageAlerts,
              },
            }));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat((customAlertModalOpen && ($attr(`display-context`) === `INSIGHTS` || $attr(`display-context`) === `FUNNELS`)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-modal", {
            "hook": {
              remove: $hooks.delayedAttrRemove(`open`, false)
            },
            "attrs": {
              open: true,
              closeable: true,
              'grow-to-content': true,
              'hide-close-button': true,
            },
            "on": {
              change: ({
                detail
              }) => (detail.state === `closed` && $helpers.closeCustomAlertModal()),
            },
          }, (function() {
            var __jade_nodes = [];
            const reportType = $helpers.getReportTypeFromContext();
            const resultsKeysAndValues = $helpers.getResultsKeysAndValues();
            __jade_nodes = __jade_nodes.concat(h("mp-custom-alert-modal", {
              "attrs": {
                'bookmark-id': $attr(`bookmark-id`),
                'enable-condition-types': $attr(`enable-custom-alert-condition-types`),
                'is-editing-mode': false,
                'is-percentage-threshold': $helpers.isPercentageThreshold(resultsKeysAndValues),
                'project-id': $attr(`project-id`),
                'report-type': reportType,
                'results-keys-and-values': JSON.stringify(resultsKeysAndValues),
                'time-unit': $attr(`time-unit`),
              },
              "on": {
                cancel: $helpers.closeCustomAlertModal,
                create: $helpers.handleCustomAlertCreated,
                error: $helpers.handleCustomAlertError,
              },
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "$hooks" in locals ? locals.$hooks : typeof $hooks !== "undefined" ? $hooks : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Number" in locals ? locals.Number : typeof Number !== "undefined" ? Number : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "bookmarkId" in locals ? locals.bookmarkId : typeof bookmarkId !== "undefined" ? bookmarkId : undefined, "customAlertModalOpen" in locals ? locals.customAlertModalOpen : typeof customAlertModalOpen !== "undefined" ? customAlertModalOpen : undefined, "open" in locals ? locals.open : typeof open !== "undefined" ? open : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;